import { render } from "./SidebarInput.vue?vue&type=template&id=56b88637&ts=true"
import script from "./SidebarInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarInput.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/sidebar/SidebarInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56b88637"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56b88637', __exports__)) {
    api.reload('56b88637', __exports__)
  }
  
  module.hot.accept("./SidebarInput.vue?vue&type=template&id=56b88637&ts=true", () => {
    api.rerender('56b88637', render)
  })

}


export default __exports__